import { Box, HStack, Image, Center, VStack } from '@chakra-ui/react';
import { TaskEvent } from '../../../models';
import { extractName, formatDateWithTime } from '../../../utils';

export const EventLogger = ({
  event: { by, at, action, task },
}: {
  event: TaskEvent;
}) => {
  return (
    <VStack
      align="start"
      border="1px"
      borderColor="#E4E7EC"
      borderRadius="md"
      p="2"
    >
      <HStack>
        {by && (
          <Box w="7" h="7" bg="custom_blue.1" borderRadius="full">
            {by.profilePictureThumbnailURL ? (
              <Image src={by?.profilePictureThumbnailURL} borderRadius="full" />
            ) : (
              <Center h="full" color="white" textTransform="capitalize">
                {extractName(`${by.firstName} `)}
              </Center>
            )}
          </Box>
        )}

        <VStack align="start">
          <HStack>
            <Box fontWeight="medium" fontSize="sm">
              {by?.firstName} {by?.lastName} ({by?.partner?.name})
            </Box>

            <Box fontSize="xs" color="custom_gray.9">
              {formatDateWithTime(new Date(at))}
            </Box>
          </HStack>

          <HStack fontWeight="medium" fontSize="sm" gap="1">
            <Box>
              <Box as="span" textTransform="capitalize">
                {action}
              </Box>{' '}
              on
            </Box>
            <Box>{task.name}</Box>
          </HStack>
        </VStack>
      </HStack>
    </VStack>
  );
};
